export const API_URL = process.env.REACT_APP_API_URL; //'https://api.cucopilot.com';
export const UI_URL = process.env.REACT_APP_UI_URL; //'https://api.cucopilot.com';
export const stripe_ind_monthly_pid = process.env.REACT_APP_STRIPE_IND_MONTHLY_PID;
export const stripe_pro_monthly_pid = process.env.REACT_APP_STRIPE_PRO_MONTHLY_PID;
export const stripe_ind_yearly_pid = process.env.REACT_APP_STRIPE_IND_YEARLY_PID;
export const stripe_pro_yearly_pid = process.env.REACT_APP_STRIPE_PRO_YEARLY_PID;

export const headers = {
    'Content-Type': 'application/json',
};